import { create } from 'zustand';

interface LayoutState {
  isDrawerCollapsed: boolean;
  setIsDrawerCollapsed: (collapsed: boolean) => void;
  toggleDrawer: () => void;
}

export const useLayoutStore = create<LayoutState>((set) => ({
  isDrawerCollapsed: false,
  setIsDrawerCollapsed: (collapsed) => set({ isDrawerCollapsed: collapsed }),
  toggleDrawer: () => set((state) => ({ isDrawerCollapsed: !state.isDrawerCollapsed })),
})); 